export default __webpack_public_path__ + "static/media/OCTDOM2026.93221d25.png";